export const VALIDATION_WARNING = 'VALIDATION_WARNING';

export type WarningState = {
    questionId?: number;
    partyId: number;
    hasMaximaValidationIssue: boolean;
}
